import { useEffect, useState } from 'react'

import { safeLocalStorage } from '@hooks/useStorage'

export const sensitiveDataFlagKey = 'areSensitiveDataHidden'

export const getLocalStorageItem = (itemName: string): string | null => {
  return safeLocalStorage.getItem(itemName)
}

export const getBooleanFromLocalStorage = (key: string, defaultValue = false): boolean => {
  const value = getLocalStorageItem(key)
  return value === null ? defaultValue : JSON.parse(value)
}

const useSensitiveDataFlag = (): boolean => {
  const [sensitiveDataFlag, setSensitiveDataFlag] = useState(() =>
    getBooleanFromLocalStorage(sensitiveDataFlagKey, false)
  )

  useEffect(() => {
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === sensitiveDataFlagKey) {
        setSensitiveDataFlag(getBooleanFromLocalStorage(sensitiveDataFlagKey, false))
      }
    }

    window.addEventListener('storage', handleStorageChange)

    return () => {
      window.removeEventListener('storage', handleStorageChange)
    }
  }, [])

  return sensitiveDataFlag
}

export default useSensitiveDataFlag
